import { useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from "react-router-dom";

const Adopt1 = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const images = [
        { id: 1, head: "SEED PROPERGATION", description: "Provide quality seeds .", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745340573/image_46_s7cifr.png" },
        { id: 2, head: "DEVELOPMENT", description: "Develop your farm", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745340573/image_46_s7cifr.png" },
        { id: 3, head: "SEED PROPERGATION", description: "Provide quality seeds .", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745340573/image_46_s7cifr.png" },
        { id: 4, head: "DEVELOPMENT", description: "Develop your farm", img: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745340573/image_46_s7cifr.png" },
    ];
    const filteredImages = images.filter((image) =>
        image.head.toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className='bg-white'>
            <div className='md:px-24 px-4 md:pt-5 pt-3'>
                <div>
                    <h1 className="text-[#FDBD26] font-bold text-[12px]  md:mt-3 md:text-[36px]">
                        ADOPT-A-FARM
                    </h1>

                    {/* Banner Section */}
                    <div className="relative rounded-lg overflow-hidden shadow-md h-[150px] md:h-[560px] md:mt-8 mt-2">
                        <img
                            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745353185/image_50_n5kemj.png"
                            alt="Shop from community"
                            className="object-cover w-full h-[150px] md:h-[500px]"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-[#2E453D] text-white flex justify-between items-center">
                            <div className="px-2 md:px-10 py-2 md:py-4">
                                <div className="font-bold text-[8px] md:text-[24px]">
                                    AFRIKA COMMUNITY
                                </div>
                                <div className="text-[6px] md:text-[24px] -mt-1 md:mt-1">
                                    Donate to support community project
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* What We Are Doing */}
                    <div className="mt-3 md:mt-8">
                        <h1 className="font-bold text-[16px] md:text-[36px]">
                            What we are doing
                        </h1>
                        <p className="text-[12px] md:text-[36px] md:-mt-2 mt-1">
                        We are supporting maize farmers by promoting value addition through training, access to processing equipment, and market linkages—enabling them to transform raw maize into profitable products like maize meal, animal feed, and other by-products."
                        </p>


                        {/* Image Grid */}
                        <div className="md:mt-8 mt-5 grid grid-cols-2 gap-2">
                            {filteredImages.map((image) => (
                                <Link
                                    key={image.id}
                                    to={
                                        image.id === 7 ? "/commsn" : "/comms"
                                    }
                                    className="flex flex-col rounded-lg"
                                >
                                    <div className="relative w-full">
                                        <img
                                            src={image.img}
                                            alt={image.name}
                                            className="w-full h-full object-cover"
                                            loading="lazy"
                                        />
                                    </div>
                                    <div className="flex justify-between items-center bg-[#F1F1F1] p-2 md:py-6 md:px-8 rounded-b-[5px]">
                                        <div>
                                            <p className="text-left font-bold text-[10px] md:text-[24px]">
                                                {image.head}
                                            </p>
                                            <p className="text-left font-normal text-[8px] md:text-[24px] md:-mt-2">
                                                {image.description}
                                            </p>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    </div>
                    {/* What are we looking for */}
                    <h1 className="font-bold text-[10px] md:text-[36px] mb-2 mt-5 md:mt-10">
                        What are we looking for
                    </h1>
                    <div className="text-[8px] md:text-[36px] md:leading-8 leading-tight md:mt-0  -mt-1">
                        <p>We are raising USD 42,000 support to build a community flour mills.</p>
                    </div>

                    {/* Donate */}
                    <h1 className="font-bold text-[10px] md:text-[36px] mt-4 mb-2 md:mt-10">
                        Donate
                    </h1>
                    <div className="text-[8px] md:text-[36px] md:leading-8 md:mt-0  -mt-1">
                        <p>Support a farmer through your donations. Thank you.</p>
                    </div>

                    {/* Choose amount title */}
                    <h1 className="font-bold text-[10px] text-center mt-6 md:mt-14 mb-2 md:text-[32px]">
                        Choose amount
                    </h1>

                    {/* How much... */}
                    <h1 className="font-bold text-[10px] md:text-[32px] md:leading-relaxed mb-4 mt-3 md:mt-6">
                        How much would you like to donate?
                    </h1>

                    {/* Donation message */}
                    <div className="text-[8px] md:text-[32px] md:leading-10 font-normal space-y-2 mb-4">
                        <p>
                            As a contributor to supporting the developments of farmers communities, we make sure your donation goes
                            directly in supporting our cause.
                        </p>
                        <p>Thank you for your support.</p>
                    </div>

                    {/* Donation buttons */}
                    <div className="grid grid-cols-5 sm:grid-cols-5 md:grid-cols-5 md:gap-4  gap-1 mt-8 md:mt-20 text-[8px] md:text-[48px] font-bold">
                        <button className="md:w-full h-[30px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white">
                            USD5
                        </button>
                        <button className="md:w-full h-[30px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white">
                            USD10
                        </button>
                        <button className="md:w-full h-[30px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white">
                            USD20
                        </button>
                        <button className="md:w-full h-[30px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white">
                            USD50
                        </button>
                        <button className="md:w-full h-[30px] md:h-[105px] rounded-md bg-[#9FAFAF] text-white text-[8px] md:text-[24px] sm:col-span-1">
                            Customise your donation
                        </button>
                    </div>
                    <div>

                        <h1 className="font-bold text-[10px] md:text-[34px] md:leading-relaxed mt-6">Donor Information.</h1>
                        <div className='md:h-[5px] bg-[#D9D9D9] w-full md:mb-3'></div>
                        <p className="text-[8px] md:text-[32px] md:leading-10 font-normal">
                            We will never share this information with anyone.
                        </p>

                        <div className="space-y-4 text-[8px] md:text-[40px] mt-4 md:mt-8">
                            <div className="flex md:flex-row gap-4 md:gap-8 font-normal">
                                <div className="relative w-full">
                                    <img
                                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC0AAAAtCAYAAAA6GuKaAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAJNSURBVHgB7ZhBTsJAFIb/Ans4wiwgcSfeoJ5AvYGeQD2BcelKb6CeQD2B9QTinuCw0133BPB/OhpNKLZvnhKSfsmkEJr2m8fr9L0BampqVk4CYxzhIQ1fcw5PBjDERJqenUajcciPRxydBad4jovZbHbNCeSIJFqawn0K38jHEqd7iu/FRj5KmsK7FL7E4ugWQvFtimdQopaW3KXwIyoKB3KKb0myQ0EDSih8Dp2w0EmS5BJKVJHu9Xr96XT6iEi0aaKKNIX3YQD/rV0oUEnP5/NNGKC9jkqa+ehggPY66gdxlWjTw8MARnoMBdr0eIIBnLzqzaiS5lJ1CwN4nSsoUEnL2sooZYiA/9adtgZRP4iUPsBH6akh51p/BCVqaakbpGJDdaTuONDWHcJalqZNRJLn+Uu73b5mjr7y6wYWF1GSRmexEf7EvN2SYopyDkGeuZtZiK49Vj2i4yFlbksB1OHK4r5ukCTvzS2j/wCjJjemcxHJHX7cR7VmwHNknMSpNm0qS4sso3fCkSISeUHJel9VvrR02CY4wcc2gTUXo9HouOzJpaQlZxnZG44+/g4f2i//24m/Soeu+x7lXh6xlBJfKh1SQhpYh//Dh+2Fwrpmae0Rctjhf3HhvoUURjqkxTNWxLLthcJIa9t7K5rNpiv6bWlOd7vdlDPuy5oc2n2Hv2Ms6zbvNWDABsPhMCs6sdLLRR7MVqslBVH6bSKarbGxyEmPKMdQVJVuKCzq6feJUEDkf9QdXzdJEs9Dzgj6yWTiLfaoa2pqaqrzBjEdGssp1CfOAAAAAElFTkSuQmCC"
                                        alt="usericon"
                                        className="md:w-[38px] md:h-[45px] w-[15px] h-[15px] absolute top-[16px] md:top-1/2 md:left-4 left-1 transform -translate-y-1/2 text-gray-500"
                                    />
                                    <input
                                        type="text"
                                        placeholder="First Name"
                                        className="w-full h-[40px] md:text-[36px] text-[10px]  md:h-[114px] md:pl-[70px] pl-[20px] border-[2px] bg-[#E7EBEB] border-[#919291] rounded-md text-black placeholder-black
          focus:outline-none focus:ring-2 focus:ring-green-900 focus:border-green-900"
                                    />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Last Name"
                                    className="w-full h-[40px] md:text-[36px] text-[10px] md:h-[114px] pl-[20px] md:pl-[70px] border-[2px] bg-[#E7EBEB] border-[#919291] rounded-md text-black placeholder-black
        focus:outline-none focus:ring-2 focus:ring-green-950 focus:border-green-950"
                                />
                            </div>

                            <div className="relative w-full">
                                <svg
                                    viewBox="0 0 24 24"
                                    className="absolute md:top-1/2 top-[20px] md:left-4 left-1 transform -translate-y-1/2 text-gray-800"
                                    height="1em"
                                    width="1em"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"></path>
                                </svg>
                                <input
                                    type="email"
                                    placeholder="Email"
                                    className="w-full h-[40px] md:text-[36px] text-[10px] pl-[20px] md:h-[114px] md:pl-[70px] border-[2px] bg-[#E7EBEB] border-[#919291] rounded-md text-black placeholder-black
        focus:outline-none focus:ring-2 focus:ring-green-900 focus:border-green-900"
                                />
                            </div>

                            <div className="relative w-full">
                                <select
                                    className="w-full h-[40px] md:text-[36px] text-[10px] appearance-none md:h-[114px] md:pl-[70px] border-[2px] bg-[#E7EBEB] border-[#919291] rounded-md text-black placeholder-black
      focus:outline-none focus:ring-2 focus:ring-green-900 focus:border-green-900"
                                    style={{
                                        WebkitAppearance: 'none', // For Webkit browsers like Chrome and Safari
                                        MozAppearance: 'none', // For Firefox
                                        appearance: 'none', // For other browsers
                                    }}
                                >
                                    <option value="Kenya">Kenya</option>
                                    <option value="Botswana">Botswana</option>
                                    <option value="Cameroon">Cameroon</option>
                                    <option value="DRC">DRC</option>
                                    <option value="Cote d'Ivoire">Cote d'Ivoire</option>
                                    <option value="Eswatini">Eswatini</option>
                                    <option value="Ethiopia">Ethiopia</option>
                                    <option value="Ghana">Ghana</option>
                                    <option value="Angola">Angola</option>
                                    <option value="Lesotho">Lesotho</option>
                                    <option value="Malawi">Malawi</option>
                                    <option value="Mozambique">Mozambique</option>
                                    <option value="Namibia">Namibia</option>
                                    <option value="Nigeria">Nigeria</option>
                                    <option value="Rwanda">Rwanda</option>
                                    <option value="Senegal">Senegal</option>
                                    <option value="Somalia">Somalia</option>
                                    <option value="South Africa">South Africa</option>
                                    <option value="South Sudan">South Sudan</option>
                                    <option value="Tanzania">Tanzania</option>
                                    <option value="Uganda">Uganda</option>
                                    <option value="Zambia">Zambia</option>
                                    <option value="Zimbabwe">Zimbabwe</option>
                                </select>

                                {/* Custom Arrow */}
                                <svg
                                    viewBox="0 0 512 512"
                                    className="absolute top-1/2 right-2  z-50 transform -translate-y-1/2 text-black pointer-events-none"
                                    height="67"
                                    width="56"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path d="M128 192l128 128 128-128z"></path>
                                </svg>
                            </div>


                            <input
                                type="text"
                                placeholder="Address line 1"
                                className="w-full h-[40px] md:text-[36px] text-[10px] md:h-[114px]  md:pl-[70px] border-[2px] bg-[#E7EBEB] border-[#919291] rounded-md text-black placeholder-black
      focus:outline-none focus:ring-2 focus:ring-green-900 focus:border-green-900"
                            />
                            <input
                                type="text"
                                placeholder="Address line 2"
                                className="w-full h-[40px] md:text-[36px] text-[10px] md:h-[114px]  md:pl-[70px] border-[2px] bg-[#E7EBEB] border-[#919291] rounded-md text-black placeholder-black
      focus:outline-none focus:ring-2 focus:ring-green-900 focus:border-green-900"
                            />
                            <div className="relative w-full">
                                <input
                                    type="text"
                                    placeholder="City"
                                    required
                                    className="w-full h-[40px] md:text-[36px] text-[10px] md:h-[114px] md:pl-[70px] border-[2px] bg-[#E7EBEB] border-[#919291] rounded-md text-black placeholder-black
        focus:outline-none focus:ring-2 focus:ring-green-900 focus:border-green-900"
                                />
                                <span className="absolute top-1/2 left-10 font-normal transform -translate-y-1/2 text-red-500">*</span>
                            </div>

                            <div className="flex flex-col md:flex-row gap-4 font-normal">
                                <input
                                    type="text"
                                    placeholder="Nairobi"
                                    className="w-full h-[40px] md:text-[36px] text-[10px] md:h-[114px] md:pl-[70px] border-[2px] bg-[#E7EBEB] border-[#919291] rounded-md text-black placeholder-black
        focus:outline-none focus:ring-2 focus:ring-green-900 focus:border-green-900"
                                />
                                <input
                                    type="text"
                                    placeholder="Zip code / Postal code"
                                    className="w-full h-[40px] md:text-[36px] text-[10px] md:h-[114px] md:pl-[70px] border-[2px] bg-[#E7EBEB] border-[#919291] rounded-md text-black placeholder-black
        focus:outline-none focus:ring-2 focus:ring-green-900 focus:border-green-900"
                                />
                            </div>
                        </div>

                        <p className=" text-[10px] md:text-[32px] mb-4 mt-6 md:mt-14 md:leading-10">To make a donation towards supporting a farmer, by direct deposit to bank, follow this steps</p>
                        <div>
                            <div className="flex items-center space-x-2 md:space-x-8 mb-4 md:mt-16">
                                <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745342198/image_1380_i2tmwd.png" alt="okicon" className="md:w-[71px] w-[20px] h-[20px] md:h-[74px]" />
                                <p className="text-[10px] md:text-[32px]  md:leading-10">I agree to the <a href='Terms_Condition'><span className="text-[#155528] underline">terms and conditions  </span></a>of the donation</p></div>
                        </div>
                        <div>
                            <div className="flex items-center justify-end space-x-2 md:space-x-4 mb-4 md:mt-16">
                                <p className="text-[10px] md:text-[32px]  md:leading-10 font-normal text-right">Edit <br />Donation</p>
                                <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745342199/image_1381_o3uhjr.png" alt="okicon" className="md:w-[60px] w-[20px] h-[20px] md:h-[60px]" />

                            </div>
                        </div>
                        <p className="text-[10px] md:text-[32px] font-bold md:leading-10">
                            Please confirm the amount you are donating.
                        </p>

                        <div className="md:space-y-6 space-y-2 mt-5">
  {/* Payment Amount */}
  <div className="flex lg:flex-row items-center justify-between lg:w-full h-[114px] border border-[#919291] rounded-md bg-[#E7EBEB] pt-4 md:pt-0">
    <input
      type="text"
      defaultValue="Payment amount"
      className="text-[10px] lg:text-[36px] font-normal lg:pl-12 pl-5 bg-transparent outline-none placeholder:text-black flex-1 h-full"
    />
    <h1 className="flex items-center justify-center w-[100px] lg:w-[396px] h-full border-2 border-[#919291] rounded-md bg-[#2E453D] text-[10px] lg:text-[36px] font-semibold text-white">
      USD 100
    </h1>
  </div>

  {/* Frequency */}
  <div className="flex lg:flex-row items-center justify-between lg:w-full h-[114px] border border-[#919291] rounded-md bg-[#E7EBEB] pt-4 md:pt-0">
    <input
      type="text"
      defaultValue="Frequency"
      className="text-[10px] lg:text-[36px] font-normal lg:pl-12 pl-5 bg-transparent outline-none placeholder:text-black flex-1 h-full"
    />
    <h1 className="flex items-center justify-center w-[100px] lg:w-[396px] h-full border-2 border-[#919291] rounded-md bg-[#2E453D] text-[10px] lg:text-[36px] font-semibold text-white">
      One time
    </h1>
  </div>

  {/* Donation Total */}
  <div className="flex lg:flex-row items-center justify-between lg:w-full h-[114px] border border-[#919291] rounded-md bg-[#E7EBEB] pt-4 md:pt-0">
    <input
      type="text"
      defaultValue="Donation Total"
      className="text-[10px] lg:text-[36px] font-semibold lg:pl-12 pl-5 bg-transparent outline-none placeholder:text-black flex-1 h-full"
    />
    <h1 className="flex items-center justify-center w-[100px] lg:w-[396px] h-full border-2 border-[#919291] rounded-md bg-[#2E453D] text-[10px] lg:text-[36px] font-semibold text-white">
      USD 100
    </h1>
  </div>
</div>




                        {/* Donate Button */}
                        <a href='/Donate1'>
                            <div className="flex md:mt-14 md:px-24 mt-8">

                                <button className="md:text-[48px] text-[16px] font-bold border-b-[5px] border-[#FDBD26] rounded-lg w-full md:h-[100px] h-[60px] px-3 flex items-center justify-center bg-[#152C24] text-white">
                                    Donate
                                </button>

                            </div>
                        </a>
                        {/* Contact Admin */}
                        <div className="flex justify-between items-start md:mt-12 mt-6">
                            <div></div>
                            <div>
                            <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1">
                                <p className="md:text-[16px] text-[10px] bg-[#FFBD26] text-white px-2 md:px-4 md:w-[255px] md:py-[9px] py-[5px] md:rounded-tl-xl rounded-tl-md font-bold md:rounded-bl-xl rounded-bl-md whitespace-nowrap">
                                    CONTACT ADMIN
                                </p>
                                <img
                                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744139834/Expand_right_2_a4wodr.png"
                                    alt="Expand"
                                    className="w-[20px] h-[10px] md:h-[42px] md:w-[55px] hidden md:flex object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl bg-[#152C24] px-2 md:py-2"
                                />
                                <img
                                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744370865/Expand_right_5_l2cjmf.png"
                                    alt="Expand"
                                    className="w-[20px] h-[22px] md:hidden flex py-[1px] md:h-[42.3px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#152C24] md:px-2 px-[2px] md:py-1"
                                />
                            </div>
                            <p className='md:text-[10px] text-[6px] font-normal md:mt-0 mt-1 text-left'>Contact administrator for more information</p>
                        </div>
                        </div>

                        <div className='md:h-12 h-2'></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Adopt1